<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Règlements
        <span class="separator" />
      </h1>
    </b-col>
    <ListeReglements />
  </div>
</template>

<script>
import ListeReglements from "@/components/libraires/reglements/ListeReglements.vue";

export default {
  name: "Reglements",
  components: {
    ListeReglements,
  },
};
</script>
<style lang="scss" scoped></style>
